import { render } from "./OddsResult.vue?vue&type=template&id=52c5170c&scoped=true"
import script from "./OddsResult.vue?vue&type=script&lang=js"
export * from "./OddsResult.vue?vue&type=script&lang=js"

import "./OddsResult.vue?vue&type=style&index=0&id=52c5170c&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c5170c"]])

export default __exports__